import { h, JSX } from 'preact';

export interface LogoutFormState {
    action: string;
    csrfToken: string;
    buttonText: string;
}

export interface LogoutFormProps extends LogoutFormState {
    buttonClass: string;
}

export const LogoutForm = (props: LogoutFormProps): JSX.Element => (
    <form action={props.action} method='POST' class='k-user-menu__form'>
        <input type='hidden' name='_token' value={props.csrfToken} />
        <button type='submit' class={props.buttonClass}>
            {props.buttonText}
        </button>
    </form>
);
